import { createContext, Dispatch, FC, SetStateAction, useContext, useState } from 'react';
import styles from './index.module.scss';
import CommonHeader from '../CommonHeader';
import Sidebar from '@/components/HomeSidebar';
import { NextPageWithLayout } from '@/pages/_app';
import useCheckLoginState from '@/hooks/useCheckLoginState';
import RecommandArea from '../RecommandArea';

// 业务组件自己决定
type PageProps = any;

export interface ResponsiveLayout {
  pageProps: PageProps;
  Component: NextPageWithLayout;
}

interface GlobalContextType {
  activeNav: string;
  setActiveNav:  Dispatch<SetStateAction<string>>;
}

const GlobalContext = createContext<GlobalContextType | undefined>(undefined);
// 三列响应式布局Layout
const ResponsiveLayout: FC<ResponsiveLayout> = ({
  Component,
  pageProps
}) => {
  const { account } = useCheckLoginState();
  const [activeNav, setActiveNav] = useState<string>('/pro/home');

  return (
    <GlobalContext.Provider value={{ activeNav, setActiveNav }}>
      <div className={styles.responsivePage}>
        <header className={styles.header}>
          <CommonHeader
            hasNav={true}
            account={account!}
            navsList={pageProps.navList || []}
            saltkey={pageProps.saltkey}
          />
        </header>
        <main className={styles.mainContent}>
          <aside className={styles.leftColumn}>
            <div className={styles.leftContent}>
              <Sidebar />
            </div>
          </aside>
          <section className={styles.centerColumn}>
            <div className={styles.centerContent}>
              <Component {...pageProps} />
            </div>
          </section>
          {
            pageProps?.sources?.id && (
              <aside className={styles.rightColumn}>
                <div className={styles.rightContent}>
                  <RecommandArea key={pageProps?.sources?.id} source={pageProps.sources} hotList={pageProps.hotList} />
                </div>
              </aside>
            )
          }
        </main>
      </div>
    </GlobalContext.Provider>
  );
};

export const useGlobalContext = () => {
  const context = useContext(GlobalContext);
  if (!context) {
    throw new Error('useGlobalContext must be used within a GlobalProvider');
  }
  return context;
};


export default ResponsiveLayout;
